<template>
  <div>
    <MglGeojsonLayer
      v-for="zone in activeZones"
      :key="zone.type"
      :sourceId="'zone-source-' + zone.type"
      :source="zone.geojson"
      :layerId="zone.fillLayer.id"
      :layer="zone.fillLayer"
    />
  </div>
</template>

<script>
import { MglGeojsonLayer } from "@/components/mapbox";
import { mapGetters } from "vuex";

export default {
  name: "Ecas",
  components: {
    MglGeojsonLayer,
  },
  computed: {
    ...mapGetters("weatherRouting/specialZones", [
      "getActiveZones"
    ]),
    activeZones() {
      return this.getActiveZones;
    },
  },
};
</script>
